<template>
  <select-dictionary
    :title="$tr('vacancy.settings.talentq.project-report-options')"
    multiple
    :value="value"
    :loaded="report_options.loaded"
    :error="report_options.error"
    :list="report_options.list || []"
    @input="$emit('input', $event)"/>
</template>
<script>

  import {createNamespacedHelpers} from 'vuex';
  import SelectDictionary from "../../components/project/select-dictionary";
  import {TALENTQ_STORE_NAMES} from "@/stores_new/vacancy_talentq/constants";

  const {mapActions, mapGetters} = createNamespacedHelpers('vacancy_talentq/' + TALENTQ_STORE_NAMES.DICTIONARY_REPORT_OPTIONS);

  export default {
    name: "report-options",
    components: {
      SelectDictionary,
    },
    props: {
      assessment_id: {
        type: Number,
        required: true,
      },
      value: {
        type: Array,
        default: null,
      },
    },
    computed: {
      ...mapGetters(['get_report_options_by_assessment_id']),
      report_options () {
        return this.get_report_options_by_assessment_id(this.assessment_id)
      }
    },
    methods: {
      ...mapActions(['load'])
    },
    created() {
      this.load(this.assessment_id);
    }
  }
</script>